<template>
    <div class="card" v-if="loadForm" v-loading="loading_submit">
        <div class="card-header bg-info" style="height: 50px; display: flex; align-items: center">
            <div style="font-size: 16px; color: #fff">{{ title }}</div>
        </div>
        <div class="card-body">
            <form autocomplete="off"
                  novalidate
                  @submit.prevent="submit">
                <div class="form-body">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="row">
                                <div class="col-6 col-xlg-2">
                                    <x-input v-model="form.number_full"
                                             readonly
                                             label="Número"
                                             v-if="form.id"></x-input>
                                    <x-select v-model="form.series"
                                              label="Serie"
                                              :options="series"
                                              option-label="number"
                                              option-value="number"
                                              v-else
                                              :disabled="!!form.id"></x-select>
                                </div>
                                <div class="col-6 col-xlg-3">
                                    <x-date-picker v-model="form.date_of_issue"
                                                   label="Fecha de emisión"></x-date-picker>
                                </div>
                                <div class="col-6 col-xlg-3">
                                    <x-date-picker v-model="form.date_of_shipping"
                                                   label="Fecha de traslado"></x-date-picker>
                                </div>
                                <div class="col-6 col-xlg-4">
                                    <x-select v-model="form.transfer_reason_type_id"
                                              label="Motivo de traslado"
                                              :options="transferReasonTypes"
                                              option-label="description"
                                              @input="changeTransferReasonType"></x-select>
                                </div>
                                <div class="col-12" v-if="form.transfer_reason_type_id === '13'">
                                    <x-input v-model="form.transfer_reason_description"
                                             label="Descripción de motivo de traslado"></x-input>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6 col-xlg-4">
                                    <x-select label="Tipo doc. rel."
                                              :options="related_document_transportations"
                                              :disabled="parentTable === 'documents'"
                                              clearable
                                              v-model="form.related_document_type_id"></x-select>
                                </div>
                                <div class="col-6 col-xlg-2">
                                    <x-input v-model="form.related_series"
                                             :readonly="parentTable === 'documents'"
                                             label="Serie doc. rel."></x-input>
                                </div>
                                <div class="col-6 col-xlg-3">
                                    <x-input v-model="form.related_number"
                                             :readonly="parentTable === 'documents'"
                                             label="Número doc. rel."></x-input>
                                </div>
                                <div class="col-6 col-xlg-3">
                                    <x-input v-model="form.related_company_number"
                                             :readonly="parentTable === 'documents'"
                                             :maxlength="11"
                                             label="RUC de la empresa"></x-input>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="x-field">
                                        <label class="control-label">Punto de partida</label>
                                        <div style="border: 1px solid #ddd; border-radius: 4px; padding: 8px 0 8px 8px; position: relative;">
                                            <div v-if="form.origin" style="padding-right: 42px">{{ form.origin.address_full }}</div>
                                            <div v-else style="cursor: pointer"
                                                 @click.prevent="clickShowDialogOriginAddressView">Click para seleccionar el punto de partida
                                            </div>
                                            <div style="position: absolute; top: 0; right: 0; height: 100%; display: flex; cursor: pointer;
                                                 align-items: center; justify-content: center; width: 42px; font-size: 24px;"
                                                 v-if="form.origin"
                                                 @click.prevent="clickClearOriginAddress">
                                                <i class="fal fa-xmark"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="x-field">
                                        <div class="x-select">
                                            <label class="x-label">Cliente</label>
                                            <div style="display: flex">
                                                <el-select v-model="form.customer_id"
                                                           :loading="loading_search"
                                                           :remote-method="searchRemoteCustomers"
                                                           filterable
                                                           placeholder="Escriba el nombre o número de documento del cliente"
                                                           popper-class="el-select-customers"
                                                           remote
                                                           class="with-button-new"
                                                           @change="changeCustomer"
                                                           @keyup.enter.native="keyupCustomer">
                                                    <el-option v-for="option in customers"
                                                               :key="option.id"
                                                               :label="option.description"
                                                               :value="option.id"></el-option>
                                                </el-select>
                                                <x-button-icon icon="fal fa-plus"
                                                               type="primary"
                                                               @click="showDialogNewPerson = true"></x-button-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="x-field">
                                        <label class="control-label">Punto de llegada</label>
                                        <div style="border: 1px solid #ddd; border-radius: 4px; padding: 8px 0 8px 8px; position: relative;">
                                            <div v-if="form.delivery" style="padding-right: 42px">{{ form.delivery.address_full }}</div>
                                            <div v-else style="cursor: pointer"
                                                 @click.prevent="showDialogDeliveryAddressView = true">Click para seleccionar el punto de llegada
                                            </div>
                                            <div style="position: absolute; top: 0; right: 0; height: 100%; display: flex; cursor: pointer;
                                                 align-items: center; justify-content: center; width: 42px; font-size: 24px;"
                                                 v-if="form.delivery"
                                                 @click.prevent="clickClearDeliveryAddress">
                                                <i class="fal fa-xmark"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <x-switch-left label="Traslado en vehículos de categoría M1 o L"
                                                   v-model="form.is_transport_category_m1l"></x-switch-left>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="row">
                                <div class="col-6 col-xlg-4">
                                    <x-select v-model="form.transport_mode_type_id"
                                              label="Modo de traslado"
                                              :options="transportModeTypes"
                                              option-label="description"
                                              @input="changeTransportModeType"></x-select>
                                </div>
                                <div class="col-6 col-xlg-8" v-if="form.transport_mode_type_id === '01'">
                                    <x-switch-left label="Registrar vehículos y conductores del transportista"
                                                   v-model="form.add_driver_and_transport"></x-switch-left>
                                </div>
                                <div class="col-6 col-xlg-4" v-if="form.is_transport_category_m1l">
                                    <x-input label="Número de placa"
                                             :maxlength="8"
                                             v-model="form.plate_number"></x-input>
                                </div>
                                <template v-if="form.transport_mode_type_id === '01' && !form.is_transport_category_m1l">
                                    <div class="col-lg-12">
                                        <x-select v-model="form.dispatcher_id"
                                                  label="Datos del transportista"
                                                  :options="dispatchers"
                                                  option-label="description"
                                                  clearable
                                                  filterable
                                                  show-button-new
                                                  @input="changeTransportModeType"
                                                  @click-new="showDialogDispatcherForm = true"></x-select>
                                    </div>
                                </template>
                                <template v-if="(form.transport_mode_type_id === '02' && !form.is_transport_category_m1l) || form.add_driver_and_transport">
                                    <div class="col-12">
                                        <x-select v-model="form.driver_id"
                                                  label="Datos del conductor"
                                                  :options="drivers"
                                                  option-label="description"
                                                  clearable
                                                  filterable
                                                  show-button-new
                                                  @click-new="showDialogDriverForm = true"></x-select>
                                    </div>
                                    <div class="col-12">
                                        <x-select v-model="form.transport_ids"
                                                  label="Datos del vehículo"
                                                  :options="transports"
                                                  option-label="description"
                                                  multiple
                                                  :multiple-limit="3"
                                                  show-button-new
                                                  filterable
                                                  @click-new="showDialogTransportForm = true"></x-select>
                                    </div>
                                </template>
                                <div class="col-12">
                                    <x-input v-model="form.observations"
                                             label="Observaciones"
                                             maxlength="250"
                                             type="textarea"></x-input>
                                </div>
                                <div class="col-6 col-xlg-4" v-if="configuration.dispatches_enable_purchase_order">
                                    <x-input label="Orden de pedido"
                                             v-model="form.order_form_external"></x-input>
                                </div>
                                <div class="col-6 col-xlg-4" v-if="configuration.dispatches_enable_seller">
                                    <x-select label="Vendedor"
                                              :options="sellers"
                                              v-model="form.seller_id"></x-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-12">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th style="width: 50px">#</th>
                                        <th style="width: 100px" class="text-center font-weight-bold">Unidad</th>
                                        <th class="font-weight-bold">Descripción</th>
                                        <th style="width: 180px" class="text-right font-weight-bold">Peso(KGM)</th>
                                        <th style="width: 180px" class="text-right font-weight-bold">Cantidad</th>
                                        <th style="width: 150px" class="text-right"></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(row, index) in form.items" :key="index">
                                        <td>{{ index + 1 }}</td>
                                        <td class="text-center">{{ row.unit_type_id }}</td>
                                        <td class="text-dark">
                                            <div style="width: 100%">{{ row.name }}</div>
                                            <div style="width: 100%" v-if="row.comment" v-html="row.comment"></div>
                                            <div style="width: 100%" v-if="row.lots && row.lots.length > 0">
                                                <el-tag v-for="l in row.lots" :key="l.id">{{ l.series }}</el-tag>
                                            </div>
                                            <div style="width: 100%" v-if="row.IdLoteSelected && row.IdLoteSelected.length > 0">
                                                <el-tag v-for="l in row.IdLoteSelected" :key="l.id">{{ l.code }}</el-tag>
                                            </div>
                                        </td>
                                        <td class="text-right">{{ row.weight }}</td>
                                        <td class="text-right">
                                            <div v-if="showItemButtonAction">{{ row.quantity }}</div>
                                            <x-input-number v-model="row.quantity"
                                                            center
                                                            :controls="true"
                                                            :min="0"
                                                            :max="row.quantity_init"
                                                            :step="1"
                                                            v-else></x-input-number>
                                        </td>
                                        <td class="text-right">
                                            <button type="button"
                                                    class="btn btn-xs btn-success"
                                                    @click.prevent="addComment(index, row.comment)">
                                                <i class="fa fa-comment"></i>
                                            </button>
                                            <button class="btn waves-effect waves-light btn-xs btn-danger"
                                                    type="button"
                                                    @click.prevent="clickRemoveItem(index)">x
                                            </button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-12 col-lg-4 col-xl-6 mb-2">
                            <x-button-icon text="Importar"
                                           icon="fal fa-upload"
                                           v-if="showItemButtonAction && configuration.dispatches_enable_import_items"
                                           @click="showDialogImport = true"></x-button-icon>
                            <x-button-icon text="Agregar Producto"
                                           icon="fal fa-plus"
                                           v-if="showItemButtonAction"
                                           @click="showDialogAddItem = true"></x-button-icon>
                        </div>
                        <div class="col-12 col-lg-8 col-xl-6">
                            <div class="row">
                                <div class="col-6 col-md-6 col-lg-4">
                                    <div :class="{'has-danger': errors.packages_number}"
                                         class="form-group">
                                        <label class="control-label">Número de paquetes</label>
                                        <el-input-number v-model="form.packages_number"
                                                         :max="9999999999"
                                                         :min="0"
                                                         :precision="0"
                                                         :step="1"></el-input-number>
                                        <small v-if="errors.packages_number"
                                               class="form-control-feedback"
                                               v-text="errors.packages_number[0]"></small>
                                    </div>
                                </div>
                                <!--                                <div class="col-12 col-md-6 col-lg-4">-->
                                <!--                                    <x-select v-model="form.unit_type_id"-->
                                <!--                                              label="Unidad de medida"-->
                                <!--                                              :options="unitTypes"-->
                                <!--                                              option-label="description"></x-select>-->
                                <!--                                </div>-->
                                <div class="col-6 col-md-6 col-lg-4">
                                    <div :class="{'has-danger': errors.total_weight}"
                                         class="form-group">
                                        <label class="control-label">Peso total<span class="text-danger"> *</span></label>
                                        <el-input-number v-model="form.total_weight"
                                                         :max="9999999999"
                                                         :min="0"
                                                         :precision="2"
                                                         :step="1"></el-input-number>
                                        <small v-if="errors.total_weight"
                                               class="form-control-feedback"
                                               v-text="errors.total_weight[0]"></small>
                                    </div>
                                </div>
                                <div class="col-6 col-md-6 col-lg-4">
                                    <x-input label="Total de unidades"
                                             v-model="totalQuantity"
                                             readonly></x-input>
                                </div>
                            </div>
                            <!--                            <table class="table">-->
                            <!--                                <tr>-->
                            <!--                                    <td style="width: 120px">-->

                            <!--                                    </td>-->
                            <!--                                    <td style="width: 120px">-->
                            <!--                                    </td>-->
                            <!--                                    <td style="width: 120px">-->
                            <!--                                    </td>-->
                            <!--                                </tr>-->
                            <!--                            </table>-->
                        </div>
                    </div>
                </div>
                <div class="form-actions text-right mt-3">
                    <x-button-cancel @click="clickClose"></x-button-cancel>
                    <x-button-native-submit text="Generar"
                                            :loading="loading_submit"
                                            v-if="form.items.length > 0"></x-button-native-submit>
                </div>
            </form>
        </div>

        <person-form :external="true"
                     :showDialog.sync="showDialogNewPerson"
                     :input_person="input_person"
                     type="customers"></person-form>

        <comment-form :show-dialog.sync="showDialogComment"
                      :commentrow="comment"
                      @addRowComment="addRowComment"></comment-form>

        <driver-form :showDialog.sync="showDialogDriverForm"
                     :transport-public-number="transportPublicNumber"
                     @success="successDriver"></driver-form>

        <dispatcher-form :showDialog.sync="showDialogDispatcherForm"
                         @success="successDispatcher"></dispatcher-form>

        <transport-form :showDialog.sync="showDialogTransportForm"
                        :transport-public-number="transportPublicNumber"
                        @success="successTransport"></transport-form>

        <origin-address-view :showDialog.sync="showDialogOriginAddressView"
                             :number-ruc="companyNumber"
                             :document-type-id="form.document_type_id"
                             :transfer-reason-type-id="form.transfer_reason_type_id"
                             type="origin"
                             @success="successOriginAddress"></origin-address-view>

        <delivery-address-view :showDialog.sync="showDialogDeliveryAddressView"
                               :number-ruc="form.customer_number"
                               :document-type-id="form.document_type_id"
                               :transfer-reason-type-id="form.transfer_reason_type_id"
                               type="delivery"
                               @success="successDeliveryAddress"></delivery-address-view>

        <dispatch-finish :recordId="recordId"
                         :showClose="false"
                         :send-sunat="send_sunat"
                         :record-data="recordData"
                         :resource="resource"
                         :parent-table="parentTable"
                         :showDialog.sync="showDialogFinish"></dispatch-finish>

        <dispatch-item-form :showDialog.sync="showDialogAddItem"
                            :configuration="config"
                            :currency-type-id-active="form.currency_type_id"
                            :exchange-rate-sale="form.exchange_rate_sale"
                            :editNameProduct="config.edit_name_product"
                            table="documents"
                            @close="closeItem"
                            @add="addRow"></dispatch-item-form>

        <store-document-items :show-dialog.sync="showDialogDocuments"
                              :resource="resource"
                              table="dispatches"
                              :document-type-id="form.document_type_id"
                              :person-id="form.customer_id"
                              @success="successDocuments"></store-document-items>

        <dispatch-import :showDialog.sync="showDialogImport"
                         @success="successImport"></dispatch-import>

    </div>
</template>

<script>
import PersonForm from '../persons/form'
import CommentForm from './Partials/Comment'
import DriverForm from './Drivers/Form.vue'
import DispatcherForm from './Dispatchers/Form'
import TransportForm from './Transports/Form'
import OriginAddressForm from './OriginAddress/Form'
import OriginAddressView from './OriginAddress/View'
import DeliveryAddressView from './OriginAddress/View'
import DeliveryAddressForm from './Partials/DispatchAddressForm'
import DispatchItemForm from './Partials/Item'
import DispatchFinish from './Partials/Finish'
import StoreDocumentItems from "../Store/DocumentItems.vue"
import DocumentFormItem from "../Documents/partials/item.vue"

import {mapState} from 'vuex/dist/vuex.mjs'
import {setDefaultSeriesByMultipleDocumentTypes} from '@mixins/functions'
import XCheckbox from "../../../components/Form/XCheckbox.vue"
import XInput from "../../../components/Form/XInput.vue"
import SeriesList from '../Documents/partials/SeriesList.vue'
import LotsGroupList from "../Documents/partials/LotsGroupList.vue"
import XSelect from "../../../components/Form/XSelect.vue"
import XButtonIcon from "../../../components/Form/XButtonIcon.vue"
import XSwitchLeft from "../../../components/Form/XSwitchLeft.vue"
import XDatePicker from "../../../components/Form/XDatePicker.vue"
import XButtonPrimary from "../../../components/Form/XButtonPrimary.vue"
import XButtonDownload from "../../../components/Form/XButtonDownload.vue"
import DispatchImport from "./Partials/Import.vue"
import XButtonCancel from "../../../components/Form/XButtonCancel.vue"
import XButtonSubmit from "../../../components/Form/XButtonSubmit.vue"
import XButtonNativeSubmit from "../../../components/Form/XButtonNativeSubmit.vue"
import OrderNoteOptions from "../Store/Finish.vue";
import XInputNumber from "../../../components/Form/XInputNumber.vue";

export default {
    props: [
        'document',
        'documentItems',
        'order_form_id',
        'configuration',
        'authUser',
        'parentTable',
        'parentId',
        'action'
    ],
    components: {
        XInputNumber,
        OrderNoteOptions,
        XButtonNativeSubmit,
        XButtonSubmit,
        XButtonCancel,
        DispatchImport,
        XButtonDownload,
        XButtonPrimary,
        XDatePicker,
        XSwitchLeft,
        XButtonIcon,
        XSelect,
        DocumentFormItem,
        XInput,
        XCheckbox,
        StoreDocumentItems,
        PersonForm,
        DispatchFinish,
        DriverForm,
        DispatcherForm,
        TransportForm,
        OriginAddressForm,
        CommentForm,
        DeliveryAddressForm,
        SeriesList,
        LotsGroupList,
        DispatchItemForm,
        OriginAddressView,
        DeliveryAddressView
    },
    // mixins: [setDefaultSeriesByMultipleDocumentTypes],
    computed: {
        ...mapState([
            'config'
        ]),
        showItemButtonAction() {
            return (this.action === 'new' && this.parentTable === null) || this.action === 'edit' || this.action === 'duplicate'
        },
        totalQuantity() {
            let total = 0
            this.form.items.forEach(row => {
                total += parseFloat(row.quantity)
            })
            return total
        }
    },
    data() {
        return {
            title: null,
            can_add_new_product: false,
            dialogExampleImport: false,
            showDialogAddItem: false,
            showDialogNewItem: false,
            showDialogAddItems: false,
            showDialogFinish: false,
            showDialogComment: false,
            showDialogNewPerson: false,
            showDialogDriverForm: false,
            showDialogTransportForm: false,
            showDialogDispatcherForm: false,
            showDialogOriginAddressForm: false,
            showDialogDeliveryAddressForm: false,
            showDialogOriginAddressView: false,
            showDialogDeliveryAddressView: false,
            showDialogDocuments: false,
            showDialogSeries: false,
            showDialogSelectLots: false,
            showDialogSelectLotsGroup: false,
            showDialogImport: false,
            IdLoteSelected: false,
            showDialogLots: false,
            min_qty: 0.0001,
            input_person: {},
            transferReasonTypes: [],
            transportModeTypes: [],
            resource: 'dispatches',
            loading_submit: false,
            establishments: [],
            comment: null,
            allDrivers: [],
            drivers: [],
            driver: null,
            dispatchers: [],
            dispatcher: null,
            countries: [],
            allSeries: [],
            series: [],
            userSeries: [],
            unitTypes: [],
            all_customers: [],
            loading_search: false,
            search_item_by_barcode: false,
            customers: [],
            code: null,
            locations: [],
            current_item: null,
            quantity: 1,
            errors: {},
            form: {},
            recordId: null,
            company: {},
            customerAddresses: [],
            showWarehousesDetail: false,
            warehousesDetail: [],
            allTransports: [],
            transports: [],
            origin: null,
            delivery: null,
            delivery_addresses: [],
            origin_addresses: [],
            send_sunat: false,
            itemSelected: null,
            warehouseId: null,
            filter_items: [],
            table: 'dispatches',
            loadForm: false,
            related_document_transportations: [],
            companyNumber: null,
            transportPublicNumber: null,
            sellers: [],
            recordData: null,
            establishmentId: null,
            sellerId: null
        }
    },
    async mounted() {
        console.log('mounted')
        this.loadForm = false
        this.initForm()
        await this.initTables()
        if (this.parentTable) {
            let url = `/store/record/${this.parentTable}/${this.parentId}/${this.resource}`
            if (this.action) {
                url += `/${this.action}`
            }
            await this.$http.get(url)
                .then(response => {
                    let data = response.data
                    this.form = Object.assign({}, this.form, data.form)
                    this.form.items = data.items
                    this.customers = data.persons
                })
            if (this.action !== 'edit') {
                this.filterSeries()
                this.changeTransportModeType()
            } else {
                this.changeTransportModeType()
            }
        } else {
            this.changeTransportModeType()
            this.filterSeries()
            this.setDefaults()
        }

        this.initFormData()

        this.title = 'Nueva guía de remisión'
        if (this.form.id) {
            this.title = 'Editar guía de remisión'
        }
        this.loadForm = true
    },
    methods: {
        async initTables() {
            await this.$http.get(`/store/get_dispatch_tables`)
                .then(response => {
                    let data = response.data
                    this.company = data.company
                    this.transferReasonTypes = data.transfer_reason_types
                    this.transportModeTypes = data.transport_mode_types
                    this.related_document_transportations = data.related_document_transportations
                    this.unitTypes = data.unit_types
                    this.all_customers = data.customers
                    this.countries = data.countries
                    this.locations = data.locations
                    this.allSeries = data.series
                    this.userSeries = data.user_series
                    this.allDrivers = data.drivers
                    this.dispatchers = data.dispatchers
                    this.allTransports = data.transports
                    this.sellers = data.sellers
                    this.sellerId = data.seller_id
                    this.establishmentId = data.establishment_id
                    this.origin = data.origin
                })
        },
        initForm() {
            this.errors = {}
            this.form = {
                id: null,
                establishment_id: null,
                document_type_id: '09',
                series: null,
                number: '#',
                date_of_issue: moment().format('YYYY-MM-DD'),
                time_of_issue: moment().format('HH:mm:ss'),
                date_of_shipping: moment().format('YYYY-MM-DD'),
                customer_id: null,
                customer_number: null,
                observations: '',
                transport_mode_type_id: '02',
                transfer_reason_type_id: '01',
                transfer_reason_description: null,
                transshipment_indicator: false,
                port_code: null,
                unit_type_id: 'KGM',
                total_weight: 1,
                total_quantity: 0,
                packages_number: 1,
                container_number: null,
                dispatcher_id: null,
                dispatcher: {},
                driver_id: null,
                driver: {},
                transport_id: null,
                transport_ids: [],
                transport: {},
                items: [],
                reference_order_form_id: null,
                secondary_license_plates: {
                    semitrailer: null
                },
                related: {},
                order_form_external: null,
                terms_condition: null,
                origin: null,
                origin_address_id: null,
                delivery: null,
                delivery_address_id: null,
                is_transport_category_m1l: false,
                plate_number: null,
                related_company_number: null,
                related_document_type_id: null,
                related_series: null,
                related_number: null,
                add_driver_and_transport: false,
            }
        },
        initFormData() {
            this.form.establishment_id = this.establishmentId
            this.form.seller_id = this.sellerId
        },
        resetForm() {
            this.initForm()
            this.initFormData()
        },
        filterSeries() {
            console.log('filterSeries')
            this.form.series = null
            this.series = this.allSeries.filter(row => {
                return row.document_type_id === this.form.document_type_id
            })
            let user_series = null
            if (this.userSeries.length > 0) {
                user_series = this.userSeries.find(row => {
                    return row.document_type_id === this.form.document_type_id
                })
            }
            if (user_series) {
                let series = this.series.find(row => {
                    return row.id === user_series.series_id
                })
                if (series) {
                    this.form.series = series.number
                    return;
                }
            }
            this.form.series = (this.series.length > 0) ? this.series[0].number : null
        },
        changeTransportModeType() {
            console.log('changeTransportModeType')
            if (this.form.transport_mode_type_id === '02') {
                this.transportPublicNumber = this.company.number
                this.drivers = this.allDrivers.filter(row => row.person_number === this.company.number)
                this.transports = this.allTransports.filter(row => row.person_number === this.company.number)
            } else {
                // this.form.driver_id = null
                // this.form.transport_ids = []
                let dis = this.dispatchers.find(row => row.id === this.form.dispatcher_id)
                this.transportPublicNumber = dis.number
                this.transports = this.allTransports.filter(row => row.person_number === dis.number)
                this.drivers = this.allDrivers.filter(row => row.person_number === dis.number)
            }
        },
        setDefaults() {
            console.log('setDefaults')
            if (this.origin) {
                this.form.origin = this.origin
            }
            if (this.drivers.length > 0) {
                let driver = this.drivers.find(row => row.is_default === true)
                this.form.driver_id = (driver) ? driver.id : this.drivers[0].id
            }
            if (this.transports.length > 0) {
                let transport = this.transports.find(row => row.is_default === true)
                this.form.transport_id = (transport) ? transport.id : this.transports[0].id
            }
            if (this.dispatchers.length > 0) {
                let dispatcher = this.dispatchers.find(row => row.is_default === true)
                this.form.dispatcher_id = (dispatcher) ? dispatcher.id : this.dispatchers[0].id
            }
        },
        changeTransferReasonType() {
            console.log('changeTransferReasonType')
            if (this.form.transfer_reason_type_id === '09' || this.form.transfer_reason_type_id === '08') {
                this.form.related_document_type_id = '50'
                this.form.related_number = null
                this.form.customer_id = null
            } else {
                this.form.related_document_type_id = null
                this.form.related_number = null
            }
        },
        addRowComment(commentNew) {
            console.log('addRowComment')
            this.form.items[this.indexrow].comment = commentNew
            this.indexrow = null
        },
        addComment(index, commentNow = null) {
            console.log('addComment')
            this.indexrow = index
            this.comment = commentNow
            this.showDialogComment = true
        },
        async reloadDataCustomers(customer_id) {
            console.log('reloadDataCustomers')
            await this.$http.get(`/documents/search/customer/${customer_id}`).then((response) => {
                this.customers = response.data.customers
            })
        },
        async changeCustomer() {
            console.log('changeCustomer')
            this.form.customer_number = null
            let customer = this.customers.find(row => row.id === this.form.customer_id)
            this.form.customer_number = customer.number
            this.form.delivery = customer.address
        },
        async searchRemoteCustomers(input) {
            console.log('searchRemoteCustomers')
            this.loading_search = true
            await this.$http.post(`/dispatch_persons/get_filter_options`, {
                'input': input,
            })
                .then(response => {
                    this.customers = response.data
                })
                .finally(() => {
                    this.loading_search = false
                })
        },
        filterCustomers() {
            console.log('filterCustomers')
            if (this.form.document_type_id === '01') {
                this.customers = this.all_customers.filter(row => row.identity_document_type_id === '6')
            } else {
                if (this.document_type_03_filter) {
                    this.customers = this.all_customers.filter(c => {
                        return c.identity_document_type_id !== '6'
                    })
                } else {
                    this.customers = this.all_customers
                }
            }
        },
        async setDefaultCustomer() {
            console.log('setDefaultCustomer')
            if (this.config.establishment.customer_id) {
                let temp_customers = this.customers
                let customer_id = this.config.establishment.customer_id
                let custom = temp_customers.find(l => l.id === customer_id)
                if (custom === undefined) {
                    await this.$http.get(`/${this.resource}/search/customer/${customer_id}`)
                        .then((response) => {
                            let data_customer = response.data.customers
                            temp_customers = temp_customers.push(...data_customer)
                        })
                    temp_customers = this.customers.filter((item, index, self) =>
                            index === self.findIndex((t) => (
                                t.id === item.id
                            ))
                    )
                    this.customers = temp_customers
                }
                let alt = this.customers.find(row => row.id === customer_id)
                if (alt !== undefined) {
                    this.form.customer_id = customer_id
                    await this.changeCustomer()
                }
            }
        },
        keyupCustomer() {
            if (this.input_person.number) {
                if (!isNaN(parseInt(this.input_person.number))) {
                    switch (this.input_person.number.length) {
                        case 8:
                            this.input_person.identity_document_type_id = '1'
                            this.showDialogNewPerson = true
                            break
                        case 11:
                            this.input_person.identity_document_type_id = '6'
                            this.showDialogNewPerson = true
                            break
                        default:
                            this.input_person.identity_document_type_id = '6'
                            this.showDialogNewPerson = true
                            break
                    }
                }
            }
        },
        clickRemoveItem(index) {
            this.form.items.splice(index, 1)
        },
        async submit() {
            if (this.form.items.some(it => it.quantity === 0)) {
                return this.$message.error(`No puede haber un item con cantidad igual a cero`);
            }

            if (this.form.related_document_type_id !== null && this.form.related_document_type_id !== '') {
                if (this.form.related_series === null || this.form.related_series === '') {
                    return this.$message.error('La serie del documento relacionado es requerido')
                }
                if (this.form.related_number === null || this.form.related_number === '') {
                    return this.$message.error('El número del documento relacionado es requerido')
                }
                if (this.form.related_company_number === null ||
                    this.form.related_company_number === '' || this.form.related_company_number.length < 11) {
                    return this.$message.error('El RUC de la empresa del documento relacionado es requerido')
                }
            } else {
                this.form.related_document_type_id = null
                this.form.related_series = null
                this.form.related_number = null
                this.form.related_company_number = null
            }

            if (this.form.origin === null) {
                return this.$message.error('El punto de partida es requerido')
            }

            if (this.form.delivery === null) {
                return this.$message.error('El punto de llegada es requerido')
            }

            if (this.config.affect_all_documents) {
                this.form.terms_condition = this.config.terms_condition_sale
            }

            if (this.form.transport_mode_type_id === '02') {
                this.form.dispatcher_id = null
                if (this.form.is_transport_category_m1l) {
                    this.form.driver_id = null
                    this.form.transport_ids = []
                } else {
                    this.form.plate_number = null
                    if (!this.form.driver_id) {
                        return this.$message.error('El conductor es requerido')
                    }
                    if (this.form.transport_ids.length === 0) {
                        return this.$message.error('El vehículo es requerido')
                    }

                }
            }

            if (this.form.transport_mode_type_id === '01') {
                if (!this.form.add_driver_and_transport) {
                    this.form.driver_id = null
                    this.form.transport_ids = []
                }
                if (this.form.is_transport_category_m1l) {
                    this.form.dispatcher_id = null
                } else {
                    this.form.plate_number = null
                    if (!this.form.dispatcher_id) {
                        return this.$message.error('El transportista es requerido')
                    }

                }
            }

            if (this.form.dispatcher_id) {
                let v = this.dispatchers.find(d => d.id === this.form.dispatcher_id)
                this.form.dispatcher.identity_document_type_id = v.identity_document_type_id
                this.form.dispatcher.number = v.number
                this.form.dispatcher.name = v.name
                this.form.dispatcher.number_mtc = v.number_mtc
                if (this.form.dispatcher.identity_document_type_id === '' || this.form.dispatcher.identity_document_type_id === null) {
                    return this.$message.error('El tipo de documento del transportista es requerido')
                }
                if (this.form.dispatcher.number === '' || _.isNull(this.form.dispatcher.number)) {
                    return this.$message.error('El número del transportista es requerido')
                }
                if (this.form.dispatcher.name === '' || _.isNull(this.form.dispatcher.name)) {
                    return this.$message.error('El nombre del transportista es requerido')
                }
            } else {
                this.form.dispatcher = null
            }

            if (this.form.driver_id) {
                this.form.driver = this.drivers.find(row => row.id === this.form.driver_id)

                if (this.form.driver.identity_document_type_id === '' || _.isNull(this.form.driver.identity_document_type_id)) {
                    return this.$message.error('El tipo de documento del conductor es requerido')
                }
                if (this.form.driver.number === '' || _.isNull(this.form.driver.number)) {
                    return this.$message.error('El número del conductor es requerido')
                }
                if (this.form.driver.name === '' || _.isNull(this.form.driver.name)) {
                    return this.$message.error('El nombre del conductor es requerido')
                }
                if (this.form.driver.license === '' || _.isNull(this.form.driver.license)) {
                    return this.$message.error('La licencia del conductor es requerido')
                }
            } else {
                this.form.driver = null
            }

            //this.form.transport = this.transports.find(row => row.id === this.form.transport_id)


            const validateQuantity = await this.verifyQuantityItems()
            if (!validateQuantity.validate) {
                return this.$message.error('Los productos no pueden tener cantidad 0.')
            }
            this.loading_submit = true
            this.$http.post(`/${this.resource}`, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                        this.resetForm()
                        this.recordData = response.data.data
                        this.send_sunat = response.data.data.send_sunat
                        this.showDialogFinish = true
                    } else {
                        this.$message.error(response.data.message)
                    }
                }).catch(error => {
                this.loading_submit = false
                if (error.response.status === 422) {
                    this.errors = error.response.data
                    let messages = Object.values(this.errors)
                    if (messages.length > 0) {
                        this.$message({
                            dangerouslyUseHTMLString: true,
                            message: messages.join('<br>'),
                            type: 'error'
                        })
                    }
                } else {
                    this.$message.error(error.response.data.message)
                }
            }).finally(() => {
                this.setDefaultCustomer()
                this.loading_submit = false
            })
        },
        clickClose() {
            location.href = '/dispatches'
        },
        verifyQuantityItems() {
            let validate = true
            let v = 0
            this.form.items.forEach((element) => {
                v = parseFloat(element.quantity)
                if (isNaN(v)) {
                    validate = false
                } else if (v < this.min_qty) {
                    validate = false
                }
            })
            return {validate}
        },
        focusDescription() {
            this.comment = null
            this.$refs.selectItem.$el.getElementsByTagName('input')[0].focus()
        },
        initInputPerson() {
            this.input_person = {
                number: null,
                identity_document_type_id: null
            }
        },
        async successDriver(id) {
            this.form.driver_id = id
            await this.$http.get(`/drivers/get_options`)
                .then(response => {
                    this.allDrivers = response.data
                    this.drivers = this.allDrivers.filter(row => row.person_number === this.transportPublicNumber)
                })
        },
        async successDispatcher(id) {
            this.form.dispatcher_id = id
            await this.$http.get(`/dispatchers/get_options`)
                .then(response => {
                    this.dispatchers = response.data
                })
        },
        async successTransport(id) {
            this.form.transport_ids.push(id)
            await this.$http.get(`/transports/get_options`)
                .then(response => {
                    this.allTransports = response.data
                    this.transports = this.allTransports.filter(row => row.person_number === this.transportPublicNumber)
                })
        },
        async successOriginAddress(data) {
            this.form.origin = data
            this.showDialogOriginAddressView = false
        },
        async successDeliveryAddress(data) {
            this.form.delivery = data
            this.showDialogDeliveryAddressView = false
        },
        clickClearOriginAddress() {
            this.form.origin = null
        },
        clickClearDeliveryAddress() {
            this.form.delivery = null
        },
        addItemImport(items) {
            items.forEach(element => {
                let it = element
                let qty = parseFloat(it.quantity)
                let exist = this.form.items.find((item) => item.id === it.id)
                let attributes = null
                if (it.attributes) {
                    attributes = it.attributes
                    this.incrementValueAttr({
                        item: it,
                        quantity: qty,
                    })
                }
                if (exist) {
                    exist.quantity += qty
                    return
                }
                let lot_group = null
                if (it.IdLoteSelected) {
                    lot_group = it.lots_group.find(l => l.id === it.IdLoteSelected)
                }
                this.form.items.push({
                    attributes: attributes,
                    description: it.description,
                    internal_id: it.internal_id,
                    quantity: qty,
                    item_id: it.id,
                    item_name: it.item_name,
                    unit_type_id: it.unit_type_id,
                    id: it.id,
                    IdLoteSelected: it.IdLoteSelected || '',
                    lot_group: lot_group || null,
                    model: it.model,
                })
            })
        },
        successDocuments(items) {
            items.forEach(it => {
                this.form.items.push(it)
            })
        },
        clickShowSeries() {
            if (this.itemSelected.lots_enabled && !this.IdLoteSelected) {
                return this.$message.error('Es requerido seleccionar el lote')
            }
            this.showDialogSelectLots = true
        },
        addRow(row) {
            console.log('addRow')
            if (this.recordItem) {
                this.form.items[this.recordItem.indexi] = row
                this.recordItem = null
            } else {
                this.form.items.push(JSON.parse(JSON.stringify(row)))
            }
        },
        closeItem() {
            console.log('closeItem')
            this.showDialogAddItem = false
            this.recordItem = null
        },
        successSeries(data) {
            this.itemSelected.quantity = data.lots.length
            this.itemSelected.IdLoteSelected = data.lotsGroup
            this.itemSelected.lots = data.lots
        },
        successLotsGroup(data) {
            this.itemSelected.quantity = data.quantity
            this.itemSelected.IdLoteSelected = data.lotsGroup
        },
        clickShowDialogOriginAddressView() {
            if (this.form.transfer_reason_type_id === '08' || this.form.transfer_reason_type_id === '09') {
                this.companyNumber = null
            } else {
                this.companyNumber = this.company.number
            }
            this.showDialogOriginAddressView = true
        },
        successImport(items) {
            items.forEach(element => {
                let it = element
                let qty = parseFloat(it.quantity)
                let exist = this.form.items.find((item) => item.id === it.id)
                if (exist) {
                    exist.quantity += qty
                    return
                }
                this.form.items.push({
                    id: it.id,
                    item_id: it.id,
                    name: it.name,
                    internal_id: it.internal_id,
                    description: it.description,
                    quantity: qty,
                    unit_type_id: it.unit_type_id,
                    IdLoteSelected: it.IdLoteSelected || '',
                    lot_group: null,
                    weight: it.weight
                })
            })
        }
    }
}
</script>
